import { useEffect, useRef, useState } from "react";
import "./App.scss";
import Footer from "./components/footer/Footer";
import About from "./pages/about/About";
import Contact from "./pages/contact/Contact";
import Home from "./pages/home/Home";
import Services from "./pages/services/Services";
import Lenis from "@studio-freight/lenis";
import Partners from "./pages/patners/Partners";
import { Navbar } from "./components/navbar/Navbar";
import AOS from "aos";
import "aos/dist/aos.css";
import SEO from "./components/seo/SEO";
import { Route, Routes } from "react-router";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ErrorPage from "./pages/error_page/ErrorPage";
function App() {
  const lenis = useRef(null);
  const [showNavbar, setShowNavbar] = useState(true);
  const lastScrollY = useRef(0);
  const [currentPage, setCurrentPage] = useState("");
  const pageRefs = useRef([]);
  const lastIdRef = useRef("");

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      once: true, // whether animation should happen only once
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const middleOfScreen = window.innerHeight / 2;

      for (const section of pageRefs.current) {
        if (!section) continue;
        const rect = section.getBoundingClientRect();

        // Check if middle of screen is inside this section
        if (rect.top <= middleOfScreen && rect.bottom >= middleOfScreen) {
          const id = section.id;
          if (id !== lastIdRef.current) {
            lastIdRef.current = id;
            setCurrentPage(id);
          }
          break; // found the active section, exit the loop
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // Initial check
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    // Initialize Lenis
    lenis.current = new Lenis({
      duration: 0.6, // Control the duration of the scroll
      easing: (t) => 1 - Math.pow(1 - t, 3), // Cubic easing for smooth stop
      smooth: true,
      smoothTouch: true, // Enable smooth scrolling on touch devices
    });

    const animate = (time) => {
      lenis.current.raf(time);
      requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);

    // 👇 Detect scroll direction
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll > lastScrollY.current && currentScroll > 50) {
        setShowNavbar(false); // scrolling down
      } else {
        setShowNavbar(true); // scrolling up
      }

      lastScrollY.current = currentScroll;
    };

    // Custom event listener for scrolling
    const handleLenisScroll = (e) => {
      lenis.current.scrollTo(e.detail);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("lenis-scroll-to", handleLenisScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("lenis-scroll-to", handleLenisScroll);
      lenis.current.destroy();
    };
  }, []);

  return (
    <div className="app_main">
      <SEO />
      <Routes>
        <Route
          path="/"
          element={
            <Main
              showNavbar={showNavbar}
              pageRefs={pageRefs}
              currentPage={currentPage}
            />
          }
        />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/*" element={<ErrorPage />} />
      </Routes>

      <Footer />
    </div>
  );
}

const Main = ({ showNavbar, currentPage, pageRefs }) => {
  return (
    <>
      <Navbar showNavbar={showNavbar} currentPage={currentPage} />
      <div id="home" ref={(el) => (pageRefs.current[0] = el)}>
        <Home />
      </div>
      <div id="about" ref={(el) => (pageRefs.current[1] = el)}>
        <About />
      </div>
      <div id="services" ref={(el) => (pageRefs.current[2] = el)}>
        <Services />
      </div>
      <div id="partners" ref={(el) => (pageRefs.current[3] = el)}>
        <Partners />
      </div>
      <div id="contact" ref={(el) => (pageRefs.current[4] = el)}>
        <Contact />
      </div>
    </>
  );
};

export default App;
